import { Link } from "react-router-dom";
import { Image } from "react-bootstrap";

import logo from '../../assets/img/logo.png';


function Header() {
    return(
        <header id="wrap-header">
            <div class="container">
                <nav class="navbar navbar-default menu-nav">
                    <div class="container-fluid">
                        <div class="navbar-header">
                            <button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#bs-example-navbar-collapse-1" aria-expanded="false">
                                <span class="sr-only">Toggle navigation</span>
                                <span class="icon-bar"></span>
                                <span class="icon-bar"></span>
                                <span class="icon-bar"></span>
                            </button>
                            <Link to="/">
                                <Image src={logo}></Image>
                            </Link>
                        </div>
                        <div class="collapse navbar-collapse" id="bs-example-navbar-collapse-1">
                            <ul class="nav navbar-nav">
                                <li><Link to="Menu">Menu System</Link></li>
                                <li><Link to="Management">Management System</Link></li>
                                <li><Link to="Ticket">Tray Ticket System</Link></li>
                                <li><Link to="Reporting">Clinical System</Link></li>
                                <li><Link to="Contact">Contact</Link></li>
                                <li><Link to="https://www.ostwologin.com/Default.aspx?ctl=Login" target="_blank" class="login">Client login</Link></li>
                            </ul>
                        </div>
                    </div>
                </nav>
            </div>
        </header>
    );
}

export default Header;